var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgOkCircleGrey = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "09_PricingPlan",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01_PrincingPlan_List",
    transform: "translate(-213.000000, -556.000000)",
    fill: "#CED0D4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PlanCard_1",
    transform: "translate(171.000000, 164.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Options",
    transform: "translate(41.000000, 162.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Option_07",
    transform: "translate(0.000000, 228.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/solid/ok-circle-Copy-15",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0000002,18.055556 C5.55103957,18.055556 1.94444438,14.4489608 1.94444438,10.0000002 C1.94444438,5.55103957 5.55103957,1.94444438 10.0000002,1.94444438 C14.4489608,1.94444438 18.055556,5.55103957 18.055556,10.0000002 C18.055556,14.4489608 14.4489608,18.055556 10.0000002,18.055556 Z M8.47222237,12.4662996 L6.47518347,10.4692608 C6.31246501,10.3065423 6.04864626,10.3065423 5.8859278,10.4692608 C5.72320934,10.6319792 5.72320934,10.895798 5.8859278,11.0585164 L8.17759454,13.3501831 C8.340313,13.5129015 8.60413175,13.5129015 8.76685021,13.3501831 L14.1140726,8.00296094 C14.2767911,7.84024249 14.2767911,7.57642376 14.1140726,7.41370531 C13.9513541,7.25098686 13.6875354,7.25098686 13.5248169,7.41370531 L8.47222237,12.4662996 Z",
    id: "Shape"
  })))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOkCircleGrey, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ok-circle-grey.ceec3ed6.svg";
export { ForwardRef as ReactComponent };